import { render, staticRenderFns } from "./ActionsData.vue?vue&type=template&id=0028c950&"
import script from "./ActionsData.vue?vue&type=script&lang=js&"
export * from "./ActionsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports